import { Component, Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { JwtHelper } from 'angular2-jwt';
import { HandleError } from "./handleError.component";
import { SessionStorageService } from "ngx-webstorage/dist/services";

const swal = require("sweetalert2");


@Injectable()
export class SessionTokenService {
    jwtHelper: JwtHelper = new JwtHelper();
    error: any;

    constructor(private handleError: HandleError, private sessionStorageService: SessionStorageService) { }
    useJwtHelper():boolean {
        //if (sessionStorage.getItem("Token") != null) {
        //if (this.sessionStorageService.retrieve("Token") == null) {
            /*let token = this.sessionStorageService.retrieve('Token');
            if (this.jwtHelper.isTokenExpired(token)) {
                this.error = { "status": 999, "message": "Token expired" };
                this.handleError.redirectUrl(this.error);
                return true;
            }*/
        //    this.error = { "status": 998, "message": "Token expired" };
        //    this.handleError.redirectUrl(this.error);
        //    return true;
        //}
        return false;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/sessionToken.service.ts